import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionCoopEditCoopSuccess, actionCoopMenuSetFirstTab, actionCoopMenuTabGoTo, TypeActionCoopInfo, } from "../actionCoop";
import { IdCoopCategory } from "../IdCoopCategory";
export var epicCoopEdit = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionCoopInfo.EditCoop), switchMap(function (action) {
        var state = state$.value;
        var coopMessage = state.coopInfo.coop ? state.coopInfo.coop.internalNotice : "";
        return deps
            .netSend({
            id: CommandCode.UpdateCoop,
            props: {
                coopId: action.coopId,
                description: action.description,
                internalNotice: coopMessage,
                joinPolicy: action.joinPolicy,
                language: action.language,
                minLevel: action.minLevel,
                playerId: state.playerInfo.playerId,
            },
        })
            .pipe(switchMap(function (res) {
            return from([
                actionCoopEditCoopSuccess(res.coop, res.project),
                actionCoopMenuSetFirstTab(IdCoopCategory.CoopInfoView),
                actionCoopMenuTabGoTo(IdCoopCategory.CoopInfoView),
            ]);
        }), retry());
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/epic/epicCoopEdit.ts
// module id = 1800
// module chunks = 3